import React, { useContext } from "react";
import { AuthContext } from "../../../../services/auth/AuthProvider";
import DataDashNav from "../../components/DataDashNav";
import DataDashMainContent from "./DataDashMainContent";
import DataDashboardDemoContent from "./DataDashboardDemoContent";

const DataDashboardSchool = () => {

    const { currentUser } = useContext(AuthContext);

    if (!currentUser) {
        return <>Loading</>
    }

    return (
        <>
            <DataDashNav />

            {currentUser.school?.canAccessDataDashboard ?
                <DataDashMainContent currentUser={currentUser} /> :
                <DataDashboardDemoContent isSchoolAdmin={currentUser.isSchoolAdmin } />
            }
        </>
    )

}

export default DataDashboardSchool;